export default [
    //装饰
    // require('../images/components/code.png'),
    // require('../images/components/kfdh.png'),
    // require('../images/components/ywhz.png'),
    //分布
    // require('../images/cooperate/code1.jpg'),
    // require('../images/cooperate/code2.jpg'),
    // require('../images/cooperate/code3.jpg'),
    // require('../images/cooperate/code4.jpg'),
    // require('../images/cooperate/code5.jpg'),
    // require('../images/cooperate/code6.jpg'),
    // require('../images/cooperate/code7.jpg'),
    // require('../images/cooperate/code8.jpg'),
    // require('../images/cooperate/code9.jpg'),
    // require('../images/cooperate/code10.jpg'),
    // require('../images/cooperate/code11.jpg'),
    // require('../images/cooperate/code12.jpg'),
    // require('../images/cooperate/code13.jpg'),
    // require('../images/cooperate/code14.jpg'),
    // require('../images/cooperate/code15.jpg'),
    // require('../images/cooperate/code16.jpg'),
    // require('../images/cooperate/cooperate-banner.jpg'),
    // require('../images/cooperate/tel.png'),
    // require('../images/cooperate/tel2.png'),
    // require('../images/cooperate/adress.png'),
    // require('../images/cooperate/bc.png'),
    //icon
    // require('../images/icon/gjdt.png'),
    // require('../images/icon/lgj.png'),
    // require('../images/icon/logo.png'),
    // require('../images/icon/mhlogo.png'),
    // require('../images/icon/sx.png'),
    // require('../images/icon/yhl.png'),
    // require('../images/icon/zcxd.png'),
    // require('../images/icon/zls.png'),
    // require('../images/icon/360logo-w.png'),
    // require('../images/icon/360logo.png'),
    //主页
    // require('../images/index/ccie/zs1.jpg'),
    // require('../images/index/ccie/zs2.jpg'),
    // require('../images/index/ccie/zs3.jpg'),
    // require('../images/index/ccie/zs4.jpg'),
    // require('../images/index/ccie/zs5.jpg'),
    // require('../images/index/ccie/zs6.jpg'),
    // require('../images/index/ccie/zs7.jpg'),
    // require('../images/index/ccie/zs8.jpg'),
    // require('../images/index/ccie/zs9.jpg'),
    // require('../images/index/ccie/zs10.jpg'),
    // require('../images/index/ccie/zs11.jpg'),
    // require('../images/index/ccie/zs12.jpg'),
    // require('../images/index/ccie/zs13.jpg'),
    // require('../images/index/ccie/zs14.jpg'),
    // require('../images/index/ccie/zs15.jpg'),
    // require('../images/index/ccie/zs16.jpg'),
    // require('../images/index/ccie/zs17.jpg'),
    // require('../images/index/ccie/zs18.png'),
    // require('../images/index/ccie/zs19.jpg'),
    // require('../images/index/ccie/zs20.png'),
    // require('../images/index/banner.jpg'),
    // require('../images/index/bg-figure-blue.png'),
    // require('../images/index/bg-figure-white.png'),
    // require('../images/index/cooperate.png'),
    // require('../images/index/flow-bg.png'),
    // require('../images/index/htaq.png'),
    // require('../images/index/kjfn.png'),
    // require('../images/index/pillar.png'),
    // require('../images/index/product.png'),
    // require('../images/index/qwlp.png'),
    //走进百昌
    // require('../images/join/bg-bd.png'),
    // require('../images/join/bg-bd2.png'),
    // require('../images/join/boss-bg.png'),
    // require('../images/join/boss-img.png'),
    // require('../images/join/bubble.png'),
    // require('../images/join/bubble-r.png'),
    // require('../images/join/close.png'),
    // require('../images/join/gd-img.png'),
    // require('../images/join/join-banner.png'),
    // require('../images/join/join-bg.png'),
    // require('../images/join/join-wh.jpg'),
    // require('../images/join/lc-dian.png'),
    // require('../images/join/play.png'),
    // require('../images/join/qm.png'),
    // require('../images/join/video-bg.png'),
    //关于我们
    // require('../images/about/about-banner.png'),
    // require('../images/about/btn-l.png'),
    // require('../images/about/btn-r-b.png'),
    // require('../images/about/btn-r.png'),
    // require('../images/about/img-no.png'),
    // require('../images/about/our-t.png'),,
    // require('../images/about/photo-load.png'),
    //产品介绍图片
    require('../images/index/banner.jpg'),
];

